import React, { useState } from 'react';
import { auth } from '../config/firebase';
import { sendPasswordResetEmail } from "firebase/auth";
import { Mail, ArrowLeft, Send, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './LoginScreen.css'; // Reutilizamos os estilos base do login

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setError('Este e-mail não está cadastrado.');
      } else {
        setError('Ocorreu um erro. Verifique o e-mail digitado.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <button className="back-btn" onClick={() => navigate('/login')} style={{ position: 'relative', top: 0, left: -10, marginBottom: 20 }}>
          <ArrowLeft size={20} /> Voltar
        </button>

        <div className="logo-section">
          <Mail size={50} color="#6366F1" />
          <h1 className="brand-name">RECUPERAR ACESSO</h1>
        </div>

        {!sent ? (
          <>
            <p style={{ color: '#64748b', marginBottom: 20, fontSize: '14px' }}>
              Digite seu e-mail abaixo. Enviaremos um link para você criar uma nova senha.
            </p>
            
            {error && <p style={{ color: '#EF4444', marginBottom: 15, fontSize: '14px' }}>{error}</p>}

            <form onSubmit={handleReset} className="login-form">
              <div className="input-wrapper">
                <Mail size={20} color="#94A3B8" className="input-icon" />
                <input
                  type="email"
                  placeholder="E-mail cadastrado"
                  className="login-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
                <Send size={18} style={{ marginLeft: 8 }} />
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <CheckCircle size={60} color="#10B981" style={{ marginBottom: 15 }} />
            <h3 style={{ color: '#1E293B', marginBottom: 10 }}>E-mail Enviado!</h3>
            <p style={{ color: '#64748b', fontSize: '14px', marginBottom: 25 }}>
              Verifique sua caixa de entrada (e a pasta de spam) e siga as instruções para redefinir sua senha.
            </p>
            <button onClick={() => navigate('/login')} className="login-button">
              Voltar para o Login
            </button>
          </div>
        )}
      </div>
    </div>
  );
}